/**
 * Computes progress percentage as an integer between 0 and 100.
 *
 * @param answered Count of earned/answered questions.
 * @param total Count of total answerable questions.
 * @returns Progress percentage rounded to the nearest integer.
 */
export function calculateProgressPercentage(answered: number, total: number): number {
  if (total <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((answered / total) * 100)));
}
